export const ENVS = {
  MODE: import.meta.env.MODE ?? '',
  CASDOOR_CLIENT_ID: import.meta.env.VITE_CASDOOR_CLIENT_ID ?? '',
  SSO_SITE_URL: import.meta.env.VITE_SSO_SITE_URL ?? '',
  CASDOOR_API_URL: import.meta.env.VITE_CASDOOR_API_URL ?? '',
  PUBLIC_URL: import.meta.env.VITE_PUBLIC_URL ?? '',
  PUBLIC_LOGOUT_URL: import.meta.env.VITE_PUBLIC_LOGOUT_URL ?? '',
  ADMIN_API_BASEURL: import.meta.env.VITE_ADMIN_API_BASEURL ?? '',
  API_BASEURL: import.meta.env.VITE_API_BASEURL ?? '',
  PUBLIC_API_BASEURL: import.meta.env.VITE_PUBLIC_API_BASEURL,
  BACKEND_URL: import.meta.env.VITE_PUBLIC_BACKEND_URL ?? '',
  LMS_URL: import.meta.env.VITE_LMS_URL ?? '',
  LMS_API_BASEURL: import.meta.env.VITE_LMS_API_BASEURL ?? '',
  LMS_LOGOUT_URL: import.meta.env.VITE_LMS_LOGOUT_URL ?? '',
  PUBLIC_PSB_URL: import.meta.env.VITE_PUBLIC_PSB_URL ?? '',
};
